export const ORGANIZATION_REGISTRATION = 'business'
export const CAMPAIGN_REGISTRATION = 'campaign'
export const AFFILIATE_REGISTRATION = 'affiliate'
export const SIGN_IN = 'sign-in'
export const SIGN_UP = 'sign-up'
export const RESET_PASSWORD = 'reset-password'
